import React from "react";



const Trending = () => {
    return(
    <>
    {/* START TEAM */}
  <div id="team">
    <div className="container">
      <div className="row d-flex align-items-center">
        <div className="col-lg-12">
          <div className="mb-30px">
            <div className="section-heading theme-text-center">
              <h1 className="head-back-light">Trending</h1>
              <h2 className="head-after">Trending Foods</h2>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="team-item">
            <div className="team-img">
              <img src="assets/images/jollof-chicken-plantain.png" alt="" />
            </div>
            <div className="team-content">
              <div className="team-header">
                <h3>Jollof Rice</h3>
                <p>With chicken, plantain, vegetables etc</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="team-item">
            <div className="team-img">
              <img src="assets/images/trending-cupcakes.png" alt="" />
            </div>
            <div className="team-content">
              <div className="team-header">
                <h3>Cupcakes</h3>
                <p>All kinds of flavours such as Vanilla, chocolate etc</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="team-item">
            <div className="team-img">
              <img src="assets/images/trending-spring-rolls.png" alt="" />
            </div>
            <div className="team-content">
              <div className="team-header">
                <h3>Spring Rolls</h3>
                <p>Chicken spring rolls, vegetable spring rolls, meat spring rolls etc</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* END TEAM */}
    </>
    )
}

export default Trending;

